import { h, FunctionComponent } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'

import {
  ChoiceStyle,
  OtherChoiceValue,
  RadioSelectField as RadioSelectFieldType,
  SelectableFieldValue,
} from 'scripts/type'
import { InlineSelect, Select } from 'components/ui'

import FieldsContext from '../fieldsContext'
import FieldWrapper from '../components/FieldWrapper'
import cn from 'classnames'

import { FieldCommonProps } from '../type'
import { PAGE_SUBMIT_DELAY } from 'scripts/constants'
import { useHandlersWithRequired } from '../hooks'
import usePropValueChange from 'components/business/SurveyForm/Fields/hooks/usePropValueChange'

const RadioSelectField: FunctionComponent<FieldCommonProps> = (props, ref) => {
  const { field, required, onFieldSubmit, onFieldChange } = props
  const [value, setValue] = useState<SelectableFieldValue>()
  const { isMultipleFields, refreshWidgetHeight } = useContext(FieldsContext)!
  const { onChange, onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit, onFieldChange)

  usePropValueChange(props, () => setValue(undefined))

  const { choices, choicesRandom, choicesSize, choicesStyle, rowChoiceCount } = field as RadioSelectFieldType
  const hasNext = useMemo(() => {
    return !required || (required && value?.value?.includes(OtherChoiceValue))
  }, [value, required])

  const handleChange = (data: SelectableFieldValue) => {
    const previousSelectOther = value?.value?.includes(OtherChoiceValue)
    const currentSelectOther = data.value?.includes(OtherChoiceValue)
    const otherChoiceChanged = previousSelectOther || currentSelectOther
    if (otherChoiceChanged && previousSelectOther !== currentSelectOther) {
      refreshWidgetHeight?.()
    }

    if (!isMultipleFields && !!value && !previousSelectOther) {
      return
    }
    setValue(data)
    if (isMultipleFields) {
      onNext()
    } else {
      required && !currentSelectOther ? setTimeout(onNext, PAGE_SUBMIT_DELAY) : onChange()
    }
  }

  return (
    <FieldWrapper {...props} handlerProps={{ visible: hasNext, onNext }}>
      {choicesStyle === ChoiceStyle.TAG ? (
        <InlineSelect
          type={'radio'}
          options={choices}
          onChange={handleChange}
          choicesRandom={choicesRandom}
          checkedOptions={value?.value}
          choicesSize={choicesSize}
          rowChoiceCount={rowChoiceCount}
          ref={ref}
        />
      ) : (
        <Select
          className={cn({
            'pointer-events-none': !isMultipleFields && !!value && !value?.value?.includes(OtherChoiceValue),
          })}
          type="radio"
          options={choices}
          onChange={handleChange}
          choicesRandom={choicesRandom}
          checkedOptions={value?.value}
        />
      )}
    </FieldWrapper>
  )
}

export default RadioSelectField
